<template>
  <div id="create">
    
    <v-speed-dial
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
    >

      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="grey darken-4"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-account-circle
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        fab
        dark
        small
        color="green"
         @click="login();"
      >
        <v-icon>mdi-account-key-outline</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="green"
         @click="register();"
      >
        <v-icon>mdi-account-plus</v-icon>
      </v-btn>
      <v-btn
       fab
        dark
        small
        color="indigo"
        @click="home();"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="red"
        @click="log();"
      >
        <v-icon>mdi-account-off-outline</v-icon>
      </v-btn>
       <v-btn
        fab
        dark
        small
        color="green"
        @click="dir();"
      >
        <v-icon>mdi-account-off-outline</v-icon>
      </v-btn>


      <v-btn
        fab
        dark
        small
        color="green"
        @click="perfilEdit();"
      >
        <v-icon>mdi-account-off-outline</v-icon>
      </v-btn>

    </v-speed-dial>
  </div>
</template>





<script>

import router from "@/router/index";


import loginService from "@/services/loginService.js";




  export default {
    data: () => ({
      direction: 'left', // direccion del boton   bottom  left rith top
      fab: false,
      fling: true,
      hover: false,
      tabs: null,
      top: false,   //ubicacion del boton 
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
    }),
  mounted() {
    
    
  },
  methods: {
    home() {

        router.push("/");
 
  },
    dir() {

        router.push("/imagenes_base");
 
  },
    login() {

        router.push("/login");
 
  },
    log() {

        loginService.logout().then(res=>{
       
            localStorage.removeItem('token');

            localStorage.removeItem('identificador');
              
        console.log("Token eliminado");

        alert("Cierre de sesion exitoso");

        router.push("/");
        }).catch(e=>{

          console.error(e.response.data.errors);

        })



 
  },
  register(){

 router.push("/register");

  }
  ,
  perfilEdit(){

    var identificador = localStorage.getItem('identificador');


if (identificador) {
      // Navegar a la ruta con el identificador como parámetro
      this.$router.push(`/perfil/${identificador}/add/`);
    } else {
      console.error('No se encontró ningún identificador en el Local Storage.');
    }

  }
  }
  }
</script>




<style>
  /*This is for documentation purposes and will not be needed in your application */
  #create .v-speed-dial {
    position: fixed;
  }

  #create .v-btn--floating {
    position: relative;
  }
</style>